<template>
    <div class="motivation-declarations-chart">
        <div v-if="loading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Загрузка...</span>
            </div>
            <p class="mt-2">Загрузка данных деклараций...</p>
        </div>
        <div v-else-if="rawChartData && rawChartData.length > 0" class="chart-wrapper">
            <CustomLineChart 
                :chartData="chartData" 
                :options="chartOptions"
            />
        </div>
        <div v-else class="text-center text-muted">
            <i class="fas fa-chart-line fa-3x mb-3"></i>
            <p>Нет данных для отображения графика деклараций</p>
        </div>
    </div>
</template>

<script>
import CustomLineChart from './CustomLineChart.vue'

export default {
    name: 'MotivationDeclarationsChart',
    components: {
        CustomLineChart
    },
    props: {
        rawChartData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Количество деклараций'
        }
    },
    computed: {
        chartData() {
            if (!this.rawChartData || this.rawChartData.length === 0) {
                return {
                    labels: [],
                    datasets: []
                }
            }

            const labels = this.rawChartData.map(item => item.month_name)
            const data = this.rawChartData.map(item => item.declarations_count)

            return {
                labels: labels,
                datasets: [{
                    label: this.title,
                    data: data,
                    borderColor: '#0d6348',
                    backgroundColor: 'rgba(13, 99, 72, 0.1)',
                    borderWidth: 3,
                    fill: true,
                    tension: 0.4,
                    pointBackgroundColor: '#0d6348',
                    pointBorderColor: '#ffffff',
                    pointBorderWidth: 2,
                    pointRadius: 6,
                    pointHoverRadius: 8,
                    pointHoverBackgroundColor: '#e37926',
                    pointHoverBorderColor: '#ffffff',
                    pointHoverBorderWidth: 3
                }]
            }
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                interaction: {
                    intersect: false,
                    mode: 'index'
                },
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#6c757d',
                            font: {
                                size: 12,
                                weight: '500'
                            }
                        }
                    },
                    y: {
                        beginAtZero: true,
                        grid: {
                            color: '#e9ecef',
                            drawBorder: false
                        },
                        ticks: {
                            color: '#6c757d',
                            font: {
                                size: 12,
                                weight: '500'
                            },
                            callback: function(value) {
                                return value
                            }
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        titleColor: '#ffffff',
                        bodyColor: '#ffffff',
                        borderColor: '#0d6348',
                        borderWidth: 1,
                        cornerRadius: 8,
                        displayColors: false,
                        callbacks: {
                            title: function(context) {
                                return context[0].label
                            },
                            label: function(context) {
                                return `Деклараций: ${context.parsed.y}`
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
.chart-wrapper {
    position: relative;
    height: 400px;
}

.motivation-declarations-chart {
    width: 100%;
}
</style>
